import { ProviderReceiptsCard } from "../../provider-receipts/ProviderReceiptsCard";
import { useProviderWorkspace } from "../ProviderWorkspaceContext";
import { useProviderWorkspaceForm } from "../ProviderWorkspaceFormContext";

export function RegisterSection() {
  const {
    isOnline,
    handleReceiptChange,
    recentSessions,
    selectedVenue,
    sessions,
  } = useProviderWorkspace();
  const { checkoutSessionId } = useProviderWorkspaceForm();

  return (
    <ProviderReceiptsCard
      checkoutSessionId={checkoutSessionId}
      isOnline={isOnline}
      onReceiptChange={handleReceiptChange}
      recentSessions={recentSessions}
      selectedVenue={selectedVenue}
      sessions={sessions}
    />
  );
}
